import { analytics } from 'affiny-core/analytics';
import { config, IInputEnv } from 'affiny-core/env';
import { logger } from 'affiny-core/logger';
import { WebAnalyticsStrategy } from 'affiny-core/services/analytics/WebAnalyticsStrategy';
import { GoogleTagManagerService } from 'affiny-core/services/googleTagManager/GoogleTagManagerService';
import {
  linkingService,
  LinkingWebStrategy,
} from 'affiny-core/services/linking';
import { LoggerWebStrategy } from 'affiny-core/services/logger/LoggerWebStrategy';
import { mediaSupportService } from 'affiny-core/services/MediaSupportStrategy';
import {
  storageService,
  StorageWebStrategy,
} from 'affiny-core/services/storage';
import { toasterService } from 'affiny-core/services/toaster/toaster';
import { ConfigStrategy } from 'affiny-web/src/services/config/ConfigStrategy';
import { MediaSupportWebStrategy } from 'affiny-web/src/services/config/MediaSupportWebStrategy';
import dayjs from 'dayjs';
import customParseFormat from 'dayjs/plugin/customParseFormat';
import localizedFormat from 'dayjs/plugin/localizedFormat';
import utc from 'dayjs/plugin/utc';
import React, { StrictMode } from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import './index.css';
import { ToasterDesktopStrategy } from './services/ToasterDesktopStrategy';
import * as serviceWorker from './services/worker';

declare const process: {
  env: IInputEnv;
};

linkingService.strategy = new LinkingWebStrategy();
toasterService.strategy = new ToasterDesktopStrategy();

config.setConfigStrategy(new ConfigStrategy());
config.configure(process.env);

logger.strategy = new LoggerWebStrategy();

analytics.configure(new WebAnalyticsStrategy());

const gtmContainerIdForGoogleAnalytics =
  config.env.googleTagManagerContainerIdForGoogleAnalytics;

if (gtmContainerIdForGoogleAnalytics)
  GoogleTagManagerService.injectTag(gtmContainerIdForGoogleAnalytics);

const gtmContainerIdForOneTrust =
  config.env.googleTagManagerContainerIdForOneTrust;

if (gtmContainerIdForOneTrust)
  GoogleTagManagerService.injectTag(gtmContainerIdForOneTrust);

storageService.strategy = new StorageWebStrategy();

// mapsService.strategy = new ProductionMapsStrategy();

mediaSupportService.strategy = new MediaSupportWebStrategy();
mediaSupportService.setAcceptHeader();

// Setup dayjs
dayjs.extend(localizedFormat);
dayjs.extend(customParseFormat);
dayjs.extend(utc);

// Init i18n
require('./i18n');

// StrictMode: enable additional checks and warnings for his chidren. (enabled only in development mode)
ReactDOM.render(
  <StrictMode>
    <App />
  </StrictMode>,
  document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
